<template>
    <div class="flex flex-col items-center justify-center h-screen w-screen relative overflow-hidden papsi-error-screen">
        <img :src="getImage('logo')" alt="Logo" class="absolute h-auto papsi-logo" />
  
        <div class="flex flex-col items-center text-center w-1/2 mt-16">
            <LabelControl class="mb-12" :content="getErrorMessage"/>
            <p class="error-message text-grey-dark text-4xl mb-4">
                {{ getErrorSubtitle }}
            </p>
            <!-- <ButtonControl @click="goBack" text="Go Back"></ButtonControl> -->
        </div>
    </div>
</template>
  
<script>
// import ButtonControl from '@/components/controls/ButtonControl.vue';
import mixin from '@/mixins/controls.js';
import LabelControl from '../controls/LabelControl.vue';
  
export default {
    name: 'v-error',
    mixins: [mixin],
    components: {
    //   ButtonControl,
      LabelControl
    },
    props: {
        is_error: {
            type: Boolean,
            default: true,
        }
    },
    computed: {
        getErrorMessage(){
            return this.is_error ? "Oops! Something went wrong" : "Sorry! We are under maintenance";
        },
        getErrorSubtitle(){
            return this.is_error ? "A technical issue has been found. We are currently fixing this. Sorry for the inconvenience." : "The kiosk is currently under scheduled maintenance. Please try again later.";
        },
    }
};
</script>
  
<style scoped>
.papsi-error-screen {
    background: radial-gradient(circle, rgba(229, 231, 235, 1) 10%, rgb(149, 155, 167) 100%);
}
  
.papsi-logo {
    top: 100px;
    left: 50%;
    transform: translateX(-50%);
    width: 15rem;
}
</style>
  